import { CALL_API, Schemas } from '../../../common/middleware/api';
import globalize from '../../../common/services/globalize';
import moment from 'moment';

export const CANCELLATION_CREDIT_NOTES_REPORT_REQUEST = 'CANCELLATION_CREDIT_NOTES_REPORT_REQUEST';
export const CANCELLATION_CREDIT_NOTES_REPORT_SUCCESS = 'CANCELLATION_CREDIT_NOTES_REPORT_SUCCESS';
export const CANCELLATION_CREDIT_NOTES_REPORT_FAILURE = 'CANCELLATION_CREDIT_NOTES_REPORT_FAILURE';

export const CANCELLATION_CREDIT_NOTES_EXPORT_REQUEST = 'CANCELLATION_CREDIT_NOTES_EXPORT_REQUEST';
export const CANCELLATION_CREDIT_NOTES_EXPORT_SUCCESS = 'CANCELLATION_CREDIT_NOTES_EXPORT_SUCCESS';
export const CANCELLATION_CREDIT_NOTES_EXPORT_FAILURE = 'CANCELLATION_CREDIT_NOTES_EXPORT_FAILURE';

export const SETTLE_REFUND_REQUEST = 'SETTLE_REFUND_REQUEST';
export const SETTLE_REFUND_SUCCESS = 'SETTLE_REFUND_SUCCESS';
export const SETTLE_REFUND_FAILURE = 'SETTLE_REFUND_FAILURE';

// an owed subscription refund has been paid back to the parent (refunds are made in the provider's dashboard)
export const settleRefund = (id, request, onSuccessEvent) => ({
	[CALL_API]: {
		types: [SETTLE_REFUND_REQUEST, SETTLE_REFUND_SUCCESS, SETTLE_REFUND_FAILURE],
		endpoint: `api/reports/cancellationCreditNotes/${id}/settle`,
		method: 'PUT',
		request,
		schema: Schemas.CANCELLATION_CREDIT_NOTES_REPORT,
		form: 'settleRefund',
		onSuccessEvent
	}
});

export const loadCancellationCreditNotesReport = (options) => ({
	[CALL_API]: {
		types: [CANCELLATION_CREDIT_NOTES_REPORT_REQUEST, CANCELLATION_CREDIT_NOTES_REPORT_SUCCESS, CANCELLATION_CREDIT_NOTES_REPORT_FAILURE],
		endpoint: `api/reports/cancellationCreditNotes`,
		request: options,
		schema: Schemas.CANCELLATION_CREDIT_NOTES_REPORT_ARRAY
	}
});

export const exportCancellationCreditNotes = (exportFormat, options, onSuccessEvent) => (dispatch, getState) => {
	dispatch({
		[CALL_API]: {
			types: [CANCELLATION_CREDIT_NOTES_EXPORT_REQUEST, CANCELLATION_CREDIT_NOTES_EXPORT_SUCCESS, CANCELLATION_CREDIT_NOTES_EXPORT_FAILURE],
			endpoint: `api/reports/cancellationCreditNotes/export/${exportFormat === 'Xero' ? 'xero' : ''}`,
			request: {
				...options,
				timeZone: globalize.getCurrentTimeZone(getState().configuration.franchisor)
			},
			onSuccessEvent
		},
		format: exportFormat,
		filename: () => `CancellationCreditNotes-${moment().format('YYYY-MM-DD')}.${exportFormat === 'Xero' ? 'csv' : 'xlsx'}`
	});
}